// extracted by mini-css-extract-plugin
export default {"toggle":"style_toggle__4yK6K"};